__turbopack_context__.v({
  "emphasis": "founder-quote-module-scss-module__BYi7RW__emphasis",
  "icon": "founder-quote-module-scss-module__BYi7RW__icon",
  "info": "founder-quote-module-scss-module__BYi7RW__info",
  "lit": "founder-quote-module-scss-module__BYi7RW__lit",
  "name": "founder-quote-module-scss-module__BYi7RW__name",
  "photo": "founder-quote-module-scss-module__BYi7RW__photo",
  "quote": "founder-quote-module-scss-module__BYi7RW__quote",
  "role": "founder-quote-module-scss-module__BYi7RW__role",
  "section": "founder-quote-module-scss-module__BYi7RW__section",
  "stage": "founder-quote-module-scss-module__BYi7RW__stage",
  "sticky": "founder-quote-module-scss-module__BYi7RW__sticky",
  "tag": "founder-quote-module-scss-module__BYi7RW__tag",
  "textCol": "founder-quote-module-scss-module__BYi7RW__textCol",
  "word": "founder-quote-module-scss-module__BYi7RW__word",
});
